import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from "./guest/login/login.component";
import {LandingComponent} from "./shared/components/outer-layouts/landing/landing.component";
import {PortalHomeComponent} from "./guest/portal/portal-home/portal-home.component";
import {PortalComponent} from "./guest/portal/portal.component";
import {RegisterComponent} from './guest/register/register.component';
import {PortalHomeCompanyComponent} from './guest/portal/portal-home-company/portal-home-company.component';
import {ResetPasswordComponent} from './guest/reset-password/reset-password.component';
import {AuthGuard} from "./guards/auth.guard";
import {UserProfileComponent} from "./guest/user-profile/user-profile.component";
import {ServiceViewComponent} from './guest/portal/service-view/service-view.component';
import {AboutTgsdComponent} from './guest/portal/citizens/citizen-header/top-nav-pages/about-tgsd/about-tgsd.component';
import {NotificationCenterComponent} from './modules/settings/notification-center/notification-center.component';
import {ContactUsComponent} from './guest/portal/contact-us/contact-us.component';
import {PrivacyPolicyComponent} from './guest/portal/privacy-policy/privacy-policy.component';
import {TermsConditionsComponent} from './guest/portal/terms-conditions/terms-conditions.component';
import {
  FrequentlyAskedQuestionComponent
} from './guest/portal/frequently-asked-question/frequently-asked-question.component';
import {AnonymousGuard} from "./guards/anonymous.guard";
import {
  TgsdClientRequestedServicesListComponent
} from "./guest/portal/tgsd-client-requested-services-list/tgsd-client-requested-services-list.component";
import {ActivateAccountComponent} from "./guest/activate-account/activate-account.component";
import {
  RequestDetailsComponent
} from "./guest/portal/tgsd-client-requested-services-list/request-details/request-details.component";
import {TgsdClientFeedbackComponent} from "./guest/portal/tgsd-client-feedback/tgsd-client-feedback.component";
import {
  FeedbackFollowUpComponent
} from "./guest/portal/tgsd-client-feedback/feedback-follow-up/feedback-follow-up.component";
import {OtpVerificationComponent} from "./guest/register/citizen/otp-verification/otp-verification.component";
import {ForgetPasswordComponent} from "./guest/forget-password/forget-password.component";
import {VerifyPhoneComponent} from "./guest/forget-password/verify-phone/verify-phone.component";
import {PasswordResetComponent} from "./guest/forget-password/password-reset/password-reset.component";
import {
  HudumaTgsdComponent
} from "./guest/portal/citizens/citizen-header/top-nav-pages/huduma-tgsd/huduma-tgsd.component";
import {
  DharuraTgsdComponent
} from "./guest/portal/citizens/citizen-header/top-nav-pages/dharura-tgsd/dharura-tgsd.component";
import {FaqTgsdComponent} from "./guest/portal/citizens/citizen-header/top-nav-pages/faq-tgsd/faq-tgsd.component";
import {FaqGeneralPageComponent} from "./guest/portal/citizens/faq-general-page/faq-general-page.component";
import {ChangePasswordComponent} from "./guest/change-password/change-password.component";
import ServicesByServiceGroupsComponent from "./guest/portal/citizens/services-new-searches/services-by-service-groups/services-by-service-groups.component";
import {NewsDetailPageComponent} from "./guest/portal/citizens/news-detail-page/news-detail-page.component";
import {SetNewPasswordComponent} from "./guest/forget-password/set-new-password/set-new-password.component";
import {AllServicesComponent} from "./guest/portal/citizens/services-new-searches/all-services/all-services.component";

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '',
    component: PortalComponent,
    children: [
      {
        path: 'home',
        component: PortalHomeComponent
      },
      {
        path: 'company-home',
        component: PortalHomeCompanyComponent
      },
      {
        path: 'register',
        component: RegisterComponent,
        canActivate: [AnonymousGuard],
      },
      {
        path: 'verify-otp/:navTo/:type/:numberOrEmail',
        component: OtpVerificationComponent,
        canActivate: [AnonymousGuard],
      },
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [AnonymousGuard],
      },
      {
        path: 'forgot-password',
        component: ForgetPasswordComponent,
        canActivate: [AnonymousGuard],
      },
      {
        path: 'set-new-password/:emailOrPhone',
        component: SetNewPasswordComponent,
        canActivate: [AnonymousGuard],
      },
      {
        path: 'citizen-verify-phone/:number',
        component: VerifyPhoneComponent,
        canActivate: [AnonymousGuard],
      },
      {
        path: 'reset-password/phone/:number',
        component: ResetPasswordComponent,
        canActivate: [AnonymousGuard],
      },
      {
        path: 'reset-password/:token',
        component: ResetPasswordComponent,
        canActivate: [AnonymousGuard],
      },
      {
        path: 'password-reset',
        component: PasswordResetComponent,
        canActivate: [AnonymousGuard],
      },
      // {
      //   path: 'reset-password-email',
      //   component: ResetPasswordEmailComponent,
      //   canActivate: [AnonymousGuard],
      // },

      {
        path: 'service-by-group/:categoryUniqueId',
        component: ServicesByServiceGroupsComponent,
        data: {
          from: 'Category'
        }
      },
      {
        path: 'service-by-special-group/:group',
        component: ServicesByServiceGroupsComponent,
        data: {
          from: 'SpecialGroup'
        }
      },
      {
        path: 'service-all',
        component: AllServicesComponent
      },

      {
        path: 'service-view/:serviceUniqueId',
        component: ServiceViewComponent
      },
      {
        path: 'news-view/:uniqueId',
        component: NewsDetailPageComponent
      },

      {
        path: 'about-tgsd',
        component: AboutTgsdComponent
      },
      {
        path: 'huduma-tgsd',
        component: HudumaTgsdComponent
      },
      {
        path: 'dharura-tgsd',
        component: DharuraTgsdComponent
      },
      {
        path: 'faq-tgsd',
        component: FaqTgsdComponent
      },
      {
        path: 'faq-tgsd/general',
        component: FaqGeneralPageComponent
      },
      {
        path: 'contact',
        component: ContactUsComponent
      },
      {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent
      },
      {
        path: 'terms-and-conditions',
        component: TermsConditionsComponent
      },
      {
        path: 'faq',
        component: FrequentlyAskedQuestionComponent
      },
      {
        path: 'client-services',
        component: TgsdClientRequestedServicesListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'client-services/:uniqueId',
        component: RequestDetailsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'client-feedback/:trackingId',
        component: TgsdClientFeedbackComponent,
        // canActivate: [AuthGuard]
      },
      {
        path: 'feedback-follow-up/:uniqueId',
        component: FeedbackFollowUpComponent,
        canActivate: [AuthGuard]
      },
    ]
  },
  {
    path: 'tgsd-landing',
    component: LandingComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'activate-account/:activationToken',
    component: ActivateAccountComponent
  },
  {
    path: 'notification-center',
    component: NotificationCenterComponent
  },
  {
    path: 'user-profile',
    component: UserProfileComponent
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent
  },
  {
    path: "system-settings",
    loadChildren: () => import("./modules/system-settings/system-settings.module").then(m => m.SystemSettingsModule),
    canActivate: [AuthGuard]
  },
  {
    path: "kiosk",
    loadChildren: () => import("./modules/kiosk/kiosk.module").then(m => m.KioskModule),
    // canActivate: [AuthGuard]
  },
  {
    path: "settings",
    loadChildren: () => import("./modules/settings/settings.module").then(m => m.SettingsModule),
    canActivate: [AuthGuard]
  },
  {
    path: "cms",
    loadChildren: () => import("./modules/cms/cms.module").then(m => m.CmsModule),
    canActivate: [AuthGuard]
  },
  {
    path: "service-management",
    loadChildren: () => import("./modules/service-management/service-management.module").then(m => m.ServiceManagementModule),
    canActivate: [AuthGuard]
  },
  {
    path: "reports",
    loadChildren: () => import("./modules/reports/reports.module").then(m => m.ReportsModule),
    canActivate: [AuthGuard]
  },
  {
    path: "feedback-processing",
    loadChildren: () => import("./modules/feedback-processing/feedback-processing.module").then(m => m.FeedbackProcessingModule),
    canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
